export default __webpack_public_path__ + "media/images/portfolio/gallery-09-480x290-900ec4cbde4a6a9c7f8a9649de859cd7.jpg";